import {Injectable} from '@angular/core';
import {Advertising} from '../model/advertising';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {UserContextService} from '../../../application/app-context/user-context/user-context.service';
import {DomainUrlService} from '../../../application/config/domain-url.service';

@Injectable({
              providedIn: 'root'
            })
export class AdvertisingService {

  readonly advertisingUrl = this.domainUrlService.getOptimPortalBackApiUrl() + '/rest/public/v1/advertising';

  constructor(private http: HttpClient,
              private userContextService: UserContextService,
              private domainUrlService: DomainUrlService) {
  }

  findAll(): Observable<Advertising[]> {
    return this.http.get(this.advertisingUrl) as Observable<Advertising[]>;
  }

  delete(advertisingId: string): Observable<any> {
    return this.http.delete(this.advertisingUrl + '/' + advertisingId) as Observable<any>;
  }

  createOrModify(advertising: Advertising): Observable<Advertising> {
    return this.http.post(this.advertisingUrl, advertising) as Observable<Advertising>;
  }

  next(): Observable<Advertising> {
    return this.http.get(this.advertisingUrl + '/next') as Observable<Advertising>;
  }

  read(advertisingId: string): Observable<Advertising> {
    return this.http.put(this.advertisingUrl + '/read/' + advertisingId, {}) as Observable<Advertising>;
  }
}
